var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtraction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1487ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78bc27"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_162",
    "data-name": "Subtraction 162",
    d: "M18,36A18,18,0,0,1,10.994,1.415,18,18,0,0,1,25.006,34.585,17.887,17.887,0,0,1,18,36ZM11.567,16.718a1.286,1.286,0,0,0-.909,2.195l3.858,3.857a1.285,1.285,0,0,0,1.746.067l9-7.714a1.285,1.285,0,1,0-1.671-1.951v0l-8.1,6.943-3.015-3.015A1.277,1.277,0,0,0,11.567,16.718Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtraction);
export default __webpack_public_path__ + "static/media/Subtraction.dba4332363b27085602495c43fa2fed9.svg";
export { ForwardRef as ReactComponent };